import { render } from "./ArticleCard.vue?vue&type=template&id=76061d9f&scoped=true"
import script from "./ArticleCard.vue?vue&type=script&lang=js"
export * from "./ArticleCard.vue?vue&type=script&lang=js"

import "./ArticleCard.vue?vue&type=style&index=0&id=76061d9f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76061d9f"]])

export default __exports__